<template>
  <div>
    <legend class="sr-only">{{ ariaLabel }}</legend>
    <div aria-hidden class="flex items-baseline">
      <div
        v-for="day in daysOfWeek"
        :key="day"
        :data-test-id="day"
        class="day-chip"
        :class="computeDayChipClass(day)"
        aria-hidden="true"
      >
        {{ day[0] }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'WeeklySchedule',
  props: {
    selectedDays: {
      type: Array,
      required: true,
    },
    closed: {
      type: Boolean,
      default: false,
      required: false,
    },
    blueVariant: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data(): any {
    return {
      daysOfWeek: ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'],
    };
  },
  computed: {
    ariaLabel() {
      if (!this.selectedDays?.length) return `No days selected`;
      return `Selected days: ${this.selectedDays?.join(', ')}`;
    },
  },
  methods: {
    computeDayChipClass(day): string {
      let classes = '';
      if (this.selectedDays.includes(day)) classes += 'selected ';
      if (this.blueVariant) classes += 'blue ';
      if (this.closed) classes += 'closed ';
      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
.day-chip {
  text-align: center;
  font-weight: 500;
  margin: 0px 4px 0 0;
  width: 24px;
  height: 24px;
  background-color: #ffffff;
  color: theme('colors.grey.text.subdued');
  border-radius: 50%;

  &:last-child {
    margin-right: 0;
  }

  &.selected {
    line-height: 22px;
    background-color: theme('colors.success.subdued');
    color: theme('colors.success.contrast');
    border: 1px solid theme('colors.success.contrast');

    &.blue {
      color: theme('colors.safety.contrast');
      background-color: theme('colors.safety.subdued');
      border: 1px solid theme('colors.safety.contrast');
    }

    &.closed {
      color: theme('colors.grey.text.subdued');
      background-color: theme('colors.grey.divider.subdued');
      border: 1px solid theme('colors.grey.text.subdued');
    }
  }
}
</style>
